const usePermisoStore = defineStore("permiso", () => {
  const permiso = ref({
    id: null,
    nombre: "",
    descripcion: "",
    beneficiable: false,
    panels: [],
    actions_disabled: [],
  });

  const permisos = ref([]);

  const draft = computed(() => clone(permiso.value));

  const getPermissionUser = computed(() => {
    return ({ rol, permisos }) => {
      return permisos.map((val) => {
        let actions = null;

        if (rol.permisos) {
          const rolPermissions = rol.permissions.find((va) => va.id == val.id);
          actions = rolPermissions
            ? JSON.parse(
                typeof rolPermissions.pivot.actions == "string"
                  ? rolPermissions.pivot.actions
                  : JSON.stringify(rolPermissions.pivot.actions)
              )
            : null;
        }

        return {
          module: val.nombre,
          descripcion: val.descripcion ?? "S/D",
          actions_disabled: val.actions_disabled,
          read:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "read")
                ? true
                : false
              : false,
          write:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "write")
                ? true
                : false
              : false,
          update:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "update")
                ? true
                : false
              : false,
          delete:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "delete")
                ? true
                : false
              : false,
        };
      });
    };
  });

  const getPermissionUsuario = computed(() => {
    return ({ permissions, permisos }) => {
      return permisos.map((val) => {
        let actions = null;

        if (permissions.length) {
          const rolPermissions = permissions.find((va) => va.id == val.id);
          if (rolPermissions != undefined) {
            return rolPermissions;
          }
        }

        return {
          id: val.id,
          module: val.nombre,
          descripcion: val.descripcion ?? "S/D",
          actions_disabled: val.actions_disabled,
          read:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "read")
                ? true
                : false
              : false,
          write:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "write")
                ? true
                : false
              : false,
          update:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "update")
                ? true
                : false
              : false,
          delete:
            actions && typeof actions === "object"
              ? actions.find((v) => v == "delete")
                ? true
                : false
              : false,
        };
      });
    };
  });

  const setPermiso = (data) => (permiso.value = data);
  const setPermisos = (data) => (permisos.value = data);

  const clearPermiso = () => {
    permiso.value = {
      id: null,
      nombre: "",
      descripcion: "",
      beneficiable: false,
      panels: [],
      actions_disabled: [],
    };
  };

  const capturarPermiso = (id_permiso) => {
    permiso.value = permisos.value.find((permiso) => permiso.id === id_permiso);
  };

  const putPermiso = (id_permiso) => {
    permisos.value.splice(
      permisos.value.findIndex((permiso) => permiso.id == id_permiso),
      1
    );
  };

  const pushPermiso = (permiso) => {
    const permis = permisos.value.find((permis) => permis.id == permiso.id);

    if (permis) {
      permisos.value.forEach((permis, i) => {
        if (permis.id == permiso.id) {
          permisos.value[i] = permiso;
        }
      });
    } else {
      permisos.value.push(permiso);
    }
  };

  const cargarPermisos = () => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/cargar/permisos")
        .then(({ data }) => {
          setPermisos(data.permisos);
          resolve(data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  };

  const guardarPermiso = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/permisos/${datos.id}`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post("/api/permisos", datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminarPermiso = async (id_permiso) => {
    return new Promise((resolve, reject) => {
      axios
        .delete("/api/permisos/" + id_permiso)
        .then(({ data }) => {
          if (data.result) {
            putPermiso(id_permiso);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetch = (permiso_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/permisos/${permiso_id}/fetch-data`)
        .then(({ data }) => {
          setPermiso(data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const fetchData = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/permisos/fetch-data`, datos)
        .then(({ data }) => {
          setPermisos(data.permisos);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const getPermiso = (id_permiso) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/permisos/${id_permiso}/get`)
        .then(({ data }) => {
          pushPermiso(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const permisosBeneficiables = () => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/permisos/beneficiables")
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    permiso,
    permisos,
    draft,
    getPermissionUser,
    getPermissionUsuario,
    setPermiso,
    setPermisos,
    clearPermiso,
    capturarPermiso,
    putPermiso,
    pushPermiso,
    cargarPermisos,
    guardarPermiso,
    eliminarPermiso,
    fetch,
    fetchData,
    getPermiso,
    permisosBeneficiables,
  };
});

export default usePermisoStore;
